<template>
  <div class="chart-window">
    <EcgChart v-for="(lbl, idx) in enabledLabels" :key="lbl" :mmPerMV="mmPerMV" :mmPerSec="mmPerSec" :max="maxValues[idx]" :chartHeight="chartHeight" :chartData="chartData[idx]" :duration="duration" :color="colors[Object.keys(colors)[idx]]" :screenWidth="screenWidth" :screenWidthInMm="screenWidthInMm" :calibrateValue="calibrateValue" :label="labels[idx]" :time="chartTime" @chartWidthChanged="chartWidthChanged"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { ColorRGBA } from 'webgl-plot'
import EcgChart from './EcgChart.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'EcgCharts',
  components: {
    EcgChart
  },
  created () {
    this.colors.lead1Color = new ColorRGBA(0 / 255, 63 / 255, 92 / 255, 0.95) // (0, 63, 92, 1)
    this.colors.lead2Color = new ColorRGBA(68 / 255, 78 / 255, 134 / 255, 0.95)
    this.colors.lead3Color = new ColorRGBA(149 / 255, 81 / 255, 150 / 255, 0.95)
    this.colors.aVRColor = new ColorRGBA(221 / 255, 81 / 255, 130 / 255, 0.95)
    this.colors.aVLColor = new ColorRGBA(255 / 255, 110 / 255, 84 / 255, 0.95)
    this.colors.aVFColor = new ColorRGBA(255 / 255, 166 / 255, 0 / 255, 0.95)

    this.installScrollHandlers = debounce(this.scrollHandlers, 300)
  },
  mounted () {
    this.calculateScreenWidthInMm()
  },
  computed: {
    enabledLabels () {
      if (this.chartData.length === 0) {
        return []
      }
      if (this.chartData.length === 1) {
        return [this.labels[0]]
      }
      return this.labels
    }
  },
  props: ['data', 'duration', 'mmPerMV', 'mmPerSec', 'chartHeight', 'monitorSize', 'monitorRatio', 'screenWidth', 'calibrateValue'],
  data: () => ({
    colors: {
      lead1Color: null,
      lead2Color: null,
      lead3Color: null,
      aVRColor: null,
      aVLColor: null,
      aVFColor: null
    },
    labels: [
      'Lead1',
      'Lead2',
      'Lead3',
      'aVR',
      'aVL',
      'aVF'
    ],
    chartData: [],
    maxValues: [],
    scrollPosition: -1,
    chartWidth: -1,
    chartViewport: -1,
    chartTime: 0,
    installScrollHandlers: null,
    screenWidthInMm: -1
  }),
  watch: {
    data: {
      deep: true,
      handler () {
        this.$emit('beforeRender')
        this.dataChanged()
        setTimeout(() => {
          this.$emit('afterRender')
        }, 4000)
      }
    },
    enabledLabels: {
      deep: true,
      handler () {
        this.installScrollHandlers()
      }
    },
    monitorSize (to, from) {
      this.calculateScreenWidthInMm()
    },
    monitorRatio (to, from) {
      this.calculateScreenWidthInMm()
    }
  },
  methods: {
    scrollHandlers () {
      var that = this
      this.enabledLabels.forEach(label => {
        var src = $(`#${label}-chart-wrapper`)
        if (src) {
          src.scroll(function () {
            that.labels.forEach(label2 => {
              if (label !== label2) {
                var dst = $(`.${label2}-chart-wrapper`)
                if (dst) {
                  dst.scrollTop(src.scrollTop())
                  dst.scrollLeft(src.scrollLeft())
                  that.scrollPosition = src.scrollLeft()

                  if (that.scrollPosition === -1 || that.chartWidth === -1 || that.chartViewport === -1) {
                    return 0
                  }

                  that.chartTime = ((that.scrollPosition / (that.chartWidth - that.chartViewport)) * that.duration).toFixed(2)
                }
              }
            })
          })
        }
      })
    },
    chartWidthChanged (width) {
      this.chartViewport = document.getElementById('Lead1-grid').getBoundingClientRect().width
      this.chartWidth = width
    },
    dataChanged () {
      this.maxValues = this.data.max
      Object.keys(this.data.leads).forEach((key, index) => {
        Vue.set(this.chartData, index, this.data.leads[key])
      })
    },
    rgbToHex (rgb) {
      var hex = Number(rgb).toString(16)
      if (hex.length < 2) {
        hex = '0' + hex
      }
      return hex
    },
    colorToHex (clr) {
      if (clr === null) {
        return '#FFF'
      }
      var red = this.rgbToHex(clr.r * 255)
      var green = this.rgbToHex(clr.g * 255)
      var blue = this.rgbToHex(clr.b * 255)
      return '#' + red + green + blue
    },
    calculateScreenWidthInMm () {
      if (!this.monitorRatio) {
        return
      }

      var r = this.monitorRatio.match(/(\d{0,2}):(\d{0,2})/)
      if (r.length < 3) {
        // ratio not valid
        return
      }
      r = r.map(function (e) {
        return parseInt(e, 10)
      })
      let inch = parseInt(this.monitorSize)
      let x = Math.sqrt(Math.pow(inch, 2) / (Math.pow(r[1], 2) + Math.pow(r[2], 2)))
      this.screenWidthInMm = 16 * x * 25.4
      console.log('screen width in mm', this.screenWidthInMm)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EcgCharts.vue